import {sendMessageApp} from '@/utils/utils';
import '@babel/polyfill';
import 'core-js/stable';
import 'regenerator-runtime/runtime';

// 哈勃上报
// import '../utils/habo.config';

window.onerror = (message, source, lineno, colno, error) => {
    console.error('Error occurred: ', message, 'at', source, 'line', lineno, ':', colno, error);
};
